import React, { useContext, useEffect, useState } from "react";

const DomiciliosItem = ({ currentRow, setCurrentRow }) => {
  return (
    <div className="DomiciliosItem__container">
      {currentRow.DireccRef != "" ? (
        <div>
          <h1>
            <span>Nombre: {currentRow.NombreRef}</span>
          </h1>
          <h1>Domilicio</h1>
          <h2>
            Dirección: {currentRow.DireccRef},Col. {currentRow.ColoniaRef}
            <br />
            Localidad: {`${currentRow.LocaliRef}`}
          </h2>
          <h2>
            C.P. {currentRow.CpRef} TEL.{currentRow.TelRef}
          </h2>
        </div>
      ) : (
        <div>
          <h1>
            <span>Sin una referencia</span>
          </h1>
        </div>
      )}
      <div>
      {currentRow.DireccRef != "" && <button
          className="btnReportarObsoleto__domicilios"
          onClick={() => setCurrentRow(currentRow)}
        >
          Ver
        </button>}
      </div>
    </div>
  );
};

export default DomiciliosItem;
